// Speed 2026-10-15: the card wishlist heart handler used to be printed inline once per product card (48 copies,
// about 135 KB, on the homepage). It now loads once from this file; the rail section (featured-collection-slider)
// adds the script tag. Behaviour unchanged: Swym add/remove on click, hearts synced from localStorage.
  // Guard: this snippet renders once per card, but the handler should bind only once.
  if (!window.__cardWishlistInit) {
    window.__cardWishlistInit = true;

    // Swym is async; queue a callback to grab the instance once it is ready.
    window.__swat = window.__swat || null;
    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(function (swat) {
      window.__swat = swat;
      // Re-sync hearts once Swym has loaded its data.
      syncCardWishlistState();
    });

    // Build the product payload Swym needs from the button's data attributes.
    var buildSwymProduct = function (btn) {
      return {
        empi: parseInt(btn.getAttribute('data-product-id'), 10),
        epi: parseInt(btn.getAttribute('data-variant-id'), 10),
        du: btn.getAttribute('data-product-url'),
        iu: btn.getAttribute('data-image'),
        dt: (btn.getAttribute('data-title') || '').trim(),
        pr: parseFloat(btn.getAttribute('data-price')),
        stk: 1
      };
    };

    // Mark cards whose product is already in the Swym wishlist as active.
    var syncCardWishlistState = function () {
      try {
        var wishlistData = JSON.parse(localStorage.getItem('swym-products'));
        var wishlistTitles = (wishlistData && wishlistData.all ? wishlistData.all : []).map(function (item) {
          return item.dt ? item.dt.trim() : '';
        });
        document.querySelectorAll('.card-wishlist-btn').forEach(function (btn) {
          var title = (btn.getAttribute('data-title') || '').trim();
          btn.classList.toggle('active', title && wishlistTitles.indexOf(title) !== -1);
        });
      } catch (e) {
        console.error('Invalid wishlist data in localStorage', e);
      }
    };

    var initCardWishlist = function () {
      syncCardWishlistState();

      // Delegate clicks so dynamically loaded cards keep working.
      document.addEventListener('click', function (event) {
        var btn = event.target.closest('.card-wishlist-btn');
        if (!btn) return;
        event.preventDefault();

        if (!window.__swat) {
          console.warn('Swym is not ready yet; wishlist not saved.');
          return;
        }

        var product = buildSwymProduct(btn);
        var isActive = btn.classList.contains('active');

        // Optimistic toggle; revert on error.
        btn.classList.toggle('active', !isActive);

        var onError = function () {
          btn.classList.toggle('active', isActive);
        };

        if (isActive) {
          window.__swat.removeFromWishList(product, function () {}, onError);
        } else {
          window.__swat.addToWishList(product, function () {}, onError);
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCardWishlist);
    } else {
      initCardWishlist();
    }
  }
